module.exports = __webpack_public_path__ + "static/img/18.4d5de84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/18.png
// module id = pe0G
// module chunks = 0